export const INITIAL_LEDGER_DB = {
  // Sundry Debtors
  "Aanand Liners":              { group: "Sundry Debtors",    balance: "15,000.00 Dr"    },
  "A K Technology":             { group: "Sundry Debtors",    balance: "8,500.00 Dr"     },
  "Allec Enterprise":           { group: "Sundry Debtors",    balance: "1,20,000.00 Dr"  },
  "Alok Enterprise":            { group: "Sundry Debtors",    balance: "45,000.00 Dr"    },
  "Alpha Automation Pvt. Ltd.": { group: "Sundry Debtors",    balance: "3,50,000.00 Dr"  },
  "Annya Enterprise":           { group: "Sundry Debtors",    balance: "12,000.00 Dr"    },
  "A.R. Enterprise":            { group: "Sundry Debtors",    balance: "0.00"            },
  "Ashwini Enterprise":         { group: "Sundry Debtors",    balance: "67,400.00 Dr"    },
  // Sundry Creditors
  "Bharat Suppliers":           { group: "Sundry Creditors",  balance: "32,000.00 Cr"    },
  "Global Traders":             { group: "Sundry Creditors",  balance: "78,500.00 Cr"    },
  "Raj Distributors":           { group: "Sundry Creditors",  balance: "1,05,000.00 Cr"  },
  // Sales
  "Local Sales @ 18%":          { group: "Sales Accounts",    balance: "14,50,000.00 Cr" },
  "Central Sales @ 18%":        { group: "Sales Accounts",    balance: "8,20,000.00 Cr"  },
  "Exempt Sales":               { group: "Sales Accounts",    balance: "1,15,000.00 Cr"  },
  "Sales Account":              { group: "Sales Accounts",    balance: "0.00"            },
  // Purchase
  "Local Purchase @ 18%":       { group: "Purchase Accounts", balance: "6,40,000.00 Dr"  },
  "Central Purchase @ 18%":     { group: "Purchase Accounts", balance: "3,10,000.00 Dr"  },
  "Exempt Purchase":            { group: "Purchase Accounts", balance: "75,000.00 Dr"    },
  "Purchase Account":           { group: "Purchase Accounts", balance: "0.00"            },
  // Duties & Taxes
  "CGST":                       { group: "Duties & Taxes",    balance: "1,200.00 Cr", taxRate: 9  },
  "SGST":                       { group: "Duties & Taxes",    balance: "1,200.00 Cr", taxRate: 9  },
  "IGST":                       { group: "Duties & Taxes",    balance: "5,400.00 Cr", taxRate: 18 },
  "Freight Charges":            { group: "Direct Expenses",   balance: "5,000.00 Dr"     },
  "Round Off":                  { group: "Indirect Expenses", balance: "0.00"            },
  "Discount":                   { group: "Indirect Expenses", balance: "0.00"            },
  // Cash & Bank
  "Cash":                       { group: "Cash-in-Hand",      balance: "25,000.00 Dr"    },
  "Petty Cash":                 { group: "Cash-in-Hand",      balance: "3,500.00 Dr"     },
  "Bank Account":               { group: "Bank Accounts",     balance: "1,80,000.00 Dr"  },
  "HDFC Current Account":       { group: "Bank Accounts",     balance: "4,25,000.00 Dr"  },
  "ICICI Savings Account":      { group: "Bank Accounts",     balance: "92,000.00 Dr"    },
  // Expenses
  "Office Expenses":            { group: "Indirect Expenses", balance: "12,000.00 Dr"    },
  "Salary Account":             { group: "Indirect Expenses", balance: "95,000.00 Dr"    },
  "Rent Account":               { group: "Indirect Expenses", balance: "36,000.00 Dr"    },
  "Telephone Expenses":         { group: "Indirect Expenses", balance: "8,400.00 Dr"     },
  // Income
  "Interest Received":          { group: "Indirect Income",   balance: "6,000.00 Cr"     },
  "Commission Received":        { group: "Indirect Income",   balance: "14,200.00 Cr"    },
};

export const INITIAL_ITEMS_DB = {
  "Dell XPS 15 Laptop":      { rate: 85000, stock: "15 Nos"  },
  "Logitech MX Master 3S":   { rate: 8500,  stock: "42 Nos"  },
  "Keychron K2 Mechanical":  { rate: 7200,  stock: "18 Nos"  },
  "Samsung 27 inch Monitor": { rate: 14500, stock: "8 Nos"   },
  "HDMI Cable 2m":           { rate: 450,   stock: "150 Nos" },
  "USB-C Hub Anker":         { rate: 3200,  stock: "25 Nos"  },
};

export const END_OF_LIST = "End of List";

export const VOUCHER_CONFIG = {
  Contra:        { key: 'F4',     useItemGrid: false, useParty: false, useJournalGrid: true,  useTaxSection: false, defaultDrCr: ['Cr', 'Dr'] },
  Payment:       { key: 'F5',     useItemGrid: false, useParty: false, useJournalGrid: true,  useTaxSection: false, defaultDrCr: ['Dr', 'Cr'] },
  Receipt:       { key: 'F6',     useItemGrid: false, useParty: false, useJournalGrid: true,  useTaxSection: false, defaultDrCr: ['Cr', 'Dr'] },
  Journal:       { key: 'F7',     useItemGrid: false, useParty: false, useJournalGrid: true,  useTaxSection: false, defaultDrCr: ['Dr', 'Cr'] },
  Sales:         { key: 'F8',     useItemGrid: true,  useParty: true,  useJournalGrid: false, useTaxSection: true,  defaultDrCr: [] },
  Purchase:      { key: 'F9',     useItemGrid: true,  useParty: true,  useJournalGrid: false, useTaxSection: true,  defaultDrCr: [] },
  'Credit Note': { key: 'Alt+F6', useItemGrid: true,  useParty: true,  useJournalGrid: false, useTaxSection: true,  defaultDrCr: [] },
  'Debit Note':  { key: 'Alt+F5', useItemGrid: true,  useParty: true,  useJournalGrid: false, useTaxSection: true,  defaultDrCr: [] },
};

export const VOUCHER_ORDER = ['Contra', 'Payment', 'Receipt', 'Journal', 'Sales', 'Purchase', 'Credit Note', 'Debit Note'];
export const JOURNAL_TYPES = new Set(['Journal', 'Contra', 'Payment', 'Receipt']);
export const HOTKEY_MAP    = { F4:'Contra', F5:'Payment', F6:'Receipt', F7:'Journal', F8:'Sales', F9:'Purchase' };
